module.exports = __webpack_public_path__ + "img/kitkitphoto7.d4a96317.jpg";